/** @format */

import React, { useState } from "react";
import { ReactComponent as ThreeDotsVertical } from "bootstrap-icons/icons/three-dots-vertical.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as X } from "bootstrap-icons/icons/x.svg";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import "./TranslationWidget.scss";
import { useLocale } from "../../i18n/hooks";
import { downloadTranslation } from "./DownloadTranslation";
import FeatureFlag from "../../featureFlag/FeatureFlag";
import StatusSwitch from "./StatusSwitch";
import UploadTranslation from "./UploadTranslation";
import "./../../notifications/ToastItem.scss";
import LoadingToast from "../../notifications/LoadingToast";
import { Resource, UserResource } from "../../resources/types";
import HelpLink from "../../helpLink/HelpLink";
import { getResourceCode } from "../../../utils/GetResourceCode";

const TranslationWidget: React.FC<{
  resource: Resource | UserResource | undefined;
  userResource: boolean;
}> = ({ resource, userResource }) => {
  const { t: _ } = useTranslation();
  const locale = useLocale();

  const [showWidget, setShowWidget] = useState<boolean>(false);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  return (
    <FeatureFlag flag={["editable", "dev"]}>
      {resource && (
        <>
          <ThreeDotsVertical
            height={"24px"}
            width={"20px"}
            aria-label="Translation"
            style={{ cursor: "pointer" }}
            onClick={() => setShowWidget(!showWidget)}
          />

          {showWidget && (
            <div
              className="bg-white border-rounded rounded-3 p-3 translation-options-wrapper text-end"
              style={{ minWidth: "100px" }}
            >
              <div className="text-dark options-dropdown">
                <X
                  className="close ms-auto"
                  viewBox="4 4 8 8"
                  onClick={() => setShowWidget(!showWidget)}
                />
                <div className="user-options pt-1">
                  {!userResource && (
                    <>
                      <>
                        <Button
                          onClick={async () => {
                            setIsDownloading(true);
                            await downloadTranslation(
                              getResourceCode(resource),
                              locale,
                            );
                            setIsDownloading(false);
                          }}
                        >
                          <Download fill="#AEAEAE" />{" "}
                          {_("Download for Translation")}
                        </Button>
                      </>
                      <UploadTranslation resource={resource as Resource} />
                    </>
                  )}

                  {resource && (
                    <StatusSwitch
                      userResource={userResource}
                      resource={resource}
                    />
                  )}
                  <HelpLink
                    className="position-relative p-0 pt-2"
                    locationId="publishing-to-live"
                    position="inherit"
                  />
                </div>
              </div>
            </div>
          )}

          <LoadingToast
            isLoading={isDownloading}
            text={`${_("Downloading")}...`}
          />
        </>
      )}
    </FeatureFlag>
  );
};

export default TranslationWidget;
